import Cookies from "universal-cookie";

const cookies = new Cookies();

const PRODUCTION_ACCOUNT_APP = "https://account.hozah.com";
const STAGING_ACCOUNT_APP = "https://staging-account.hozah.com";

// Staging's account app is staging-account.hozah.com, NOT account.hozah-staging.com
// -- that name resolves (wildcard onto the parking LB) but serves nothing.
const accountAppOrigin = () =>
  window.location.hostname === "my.hozah-staging.com" ? STAGING_ACCOUNT_APP : PRODUCTION_ACCOUNT_APP;

export const ACCOUNT_APP_LOGIN = "/login";
// flow=autopay is what carries the driver on to /autopay after the account exists.
export const ACCOUNT_APP_SIGNUP = "/signup?flow=autopay";
export const ACCOUNT_APP_VEHICLES = "/vehicles";
export const ACCOUNT_APP_ADD_VEHICLE = "/vehicles/add";
// Two targets, not one: /autopay always creates a vehicle, so pointing a driver who
// already has one at it conflicts instead of taking their card.
export const ACCOUNT_APP_AUTOPAY = "/autopay";
export const ACCOUNT_APP_CARD = "/settings/card";

export const accountAppUrl = (path = "") => `${accountAppOrigin()}${path}`;

export const redirectToAccountApp = (path = "") => {
  window.location.replace(accountAppUrl(path));
};

// Set by ?referer=account, which is where the account app's "Old version" button
// lands. Ignore it and that button bounces the driver straight back.
export const isPinnedToLegacyApp = () => cookies.get("version") === "old";

// Root only. Widening this to every path is what ate /auth-callback (ISME-4625)
// and direct links to /dashboard -- the same bug twice.
export const shouldSendActivatedAccountToAccountApp = () =>
  window.location.pathname === "/" && !isPinnedToLegacyApp();
